import React from "react";
import {
  MULTI_ADMIN_PAYMENT_REPORT_TABLE_CONST_KEYS,
  MULTI_ADMIN_POINTS_REPORT_TABLE_CONST_KEYS,
  XOXO_POINT_SCHEDULER_CONSTANT,
  MULTI_ADMIN_XOXO_CODE_REPORT_TABLE_CONST_KEYS,
  XOXO_CODE_SCHEDULER_CONSTANT,
  XOXO_LINK_DISTRIBUTED_TABLE_KEYS,
  XOXO_LINK_SENT_TO_SELF_KEYS,
} from "./constants";
import ReportService from "../../../services/reportService";
import ProfileService from "../../../services/profileService";
import BulkProcessService from "../../../services/bulkProcessService";
import Reports from "../Reports";
import { PLUM_PRO_REPORT_KEYS } from "../PlumProReport/constants";
import { ACL_MODULE_MAPPING } from "../../../constants/RouteConstant";

const env = process.env.NODE_ENV || "production";
const config = require(`../../../config/config.${env}.json`);

const initialFetchParams = {
  offset: 0,
  limit: 10,
};

const initialData = [
  // {
  //   title: "Payments",
  //   module_id: 1,
  //   data: [
  //     {
  //       columns: MULTI_ADMIN_PAYMENT_REPORT_TABLE_CONST_KEYS,
  //       fetchData: ReportService.multiAdminPaymentsReport,
  //       downloadFile: "plum_multiadmin_payments",
  //       downloadData: ProfileService.plumReportGetCsv,
  //       showCheckBox: false,
  //     },
  //   ],
  // },
  {
    title: "Reward Points",
    module_id: 2,
    categoryTitle: "status",
    fetchCount: ReportService.getPlumMultiAdminPointsCount,
    data: [
      {
        title: "Sent",
        columns: MULTI_ADMIN_POINTS_REPORT_TABLE_CONST_KEYS,
        fetchData: ReportService.multiAdminPointReport,
        downloadFile: "plum_multiadmin_points",
        downloadData: ProfileService.plumReportGetCsv,
        showCheckBox: true,
      },
      {
        title: "Scheduled",
        columns: XOXO_POINT_SCHEDULER_CONSTANT,
        fetchData: BulkProcessService.fetchSchedulerReport,
        downloadData: ProfileService.plumReportGetCsv,
        showCheckBox: false,
      },
    ],
  },
  {
    title: "Reward Code",
    module_id: 3,
    categoryTitle: "status",
    fetchCount: ReportService.getPlumMultiAdminVoucherCount,
    data: [
      {
        title: "Sent",
        columns: MULTI_ADMIN_XOXO_CODE_REPORT_TABLE_CONST_KEYS,
        fetchData: ReportService.multiAdminVoucherReport,
        downloadFile: "plum_multiadmin_voucher",
        downloadData: ProfileService.plumReportGetCsv,
        showCheckBox: true,
      },
      {
        title: "Scheduled",
        columns: XOXO_CODE_SCHEDULER_CONSTANT,
        fetchData: BulkProcessService.fetchSchedulerReport,
        downloadData: ProfileService.plumReportGetCsv,
        showCheckBox: false,
      },
    ],
  },
  {
    title: "Reward Link",
    module_id: 12,
    data: [
      {
        title: "Send to recipients",
        columns: XOXO_LINK_DISTRIBUTED_TABLE_KEYS,
        fetchData: ReportService.getXoxoLinkReportsTable,
        downloadFile: "plum_multiadmin_link_distributed",
        downloadData: ReportService.plumReportGetCsv,
        showCheckBox: true,
      },
      {
        title: "Sent to self",
        columns: XOXO_LINK_SENT_TO_SELF_KEYS,
        fetchData: ReportService.getXoxoLinkReportsTable,
        downloadFile: "plum_multiadmin_link_distributed",
        downloadData: ReportService.plumReportGetCsv,
        showCheckBox: true,
      },
    ],
  },
  {
    title: "Gift Cards",
    module_id: 6,
    fetchCount: ReportService.getTotalReportCount,
    data: [
      {
        columns: PLUM_PRO_REPORT_KEYS,
        fetchData: ReportService.plumProOrderReport,
        downloadFile: "plumpro_payments",
        downloadData: ProfileService.plumReportGetCsv,
        showCheckBox: true,
      },
    ],
  },
];

const XoxoTokenReports = (props) => {
  let moduleAcl = props?.accountReducer?.moduleAcl?.map(
    (module) => module.module_id
  );

  const isProcurementApprovalRequired =
    props?.accountReducer?.platformSettings?.isProcurementApprovalRequired;

  let newInitialData = initialData.filter((data) => {
    if (data.title === "Reward Code" && isProcurementApprovalRequired) {
      data.data[1].title = "Approval Pending";
    }
    const isEnabled = moduleAcl.includes(data?.module_id);
    if (
      props.accountReducer.typeData.role === 100 &&
      data.title === "Payments"
    ) {
      return false;
    }
    if (data.title === "Gift Cards") {
      return (
        moduleAcl.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
        moduleAcl.includes(ACL_MODULE_MAPPING.PLUM_PRO_API)
      );
    }
    return isEnabled;
  });
  return (
    <Reports
      {...props}
      initialData={newInitialData}
      initialFetchParams={initialFetchParams}
      type="xoxo_token_report"
    />
  );
};

export default XoxoTokenReports;
